/*global Ractive, RedmarineUXTemplates, BaseComponent */

Ractive.components['ux-simpleblock'] = BaseComponent.extend({

	template: RedmarineUXTemplates.uxsimpleblockUxsimpleblock,

	data: {
		component: 'ux-simpleblock',
		isActive: true,
		disableToggling: true,
		truncate: false,
		limit: 0
	},

	computed: {
		itemsList: function() {
			var items = this.get('items'),
				limit = this.get('limit');

			if (limit > 0) {
				items = items.slice(0, limit);
			}

			return items;
		}
	},
	onrender: function() {
		this.on('toggleBlock', function(event) {
			event.original.preventDefault();
			this.toggle('isActive');
		}.bind(this));
	}

});
